import { render, staticRenderFns } from "./Chat_mantenimiento.vue?vue&type=template&id=7d08c606&scoped=true"
import script from "./Chat_mantenimiento.vue?vue&type=script&lang=js"
export * from "./Chat_mantenimiento.vue?vue&type=script&lang=js"
import style0 from "./Chat_mantenimiento.vue?vue&type=style&index=0&id=7d08c606&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d08c606",
  null
  
)

export default component.exports